import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ModifierGroupsClient } from '../../api/ModifierGroupsClient';
import { ModifiersClient } from '../../api/ModifiersClient';
import { createDisplayedModifiers } from '../../utils/modifiers';
import { settleApiCall } from '../../api/utils';
import { createOrUpdateModifierGroups } from '../../actions/createOrUpdateModifierGroups';
import { getModifiers } from './actions/getModifiers';
import { modifierGroupRuleAdapter } from '../../utils/adapters';
export class PopulatedModifierGroupClient {
  constructor(_ref) {
    let {
      request,
      populationLevel
    } = _ref;
    _defineProperty(this, "populationLevel", void 0);
    _defineProperty(this, "modifiersClient", void 0);
    _defineProperty(this, "modifierGroupsClient", void 0);
    this.populationLevel = populationLevel;
    this.modifiersClient = new ModifiersClient(request);
    this.modifierGroupsClient = new ModifierGroupsClient(request);
  }
  async createOrUpdate(_ref2) {
    let {
      modifierGroups
    } = _ref2;
    const createOrUpdateModifierGroupsResponse = await createOrUpdateModifierGroups({
      modifierGroups,
      modifierGroupsClient: this.modifierGroupsClient,
      modifiersClient: this.modifiersClient
    });
    if (createOrUpdateModifierGroupsResponse.hasError) {
      return createOrUpdateModifierGroupsResponse;
    }
    return {
      data: createOrUpdateModifierGroupsResponse.data,
      hasError: false
    };
  }
  async getById(modifierGroupId) {
    const modifierGroupsApiResponse = await settleApiCall(() => this.modifierGroupsClient.getById(modifierGroupId));
    if (modifierGroupsApiResponse.hasError) {
      return modifierGroupsApiResponse;
    }
    const populateModifierGroupsResponse = await this.createPopulatedModifierGroups([modifierGroupsApiResponse.data]);
    if (populateModifierGroupsResponse.hasError) {
      return populateModifierGroupsResponse;
    }
    return {
      data: populateModifierGroupsResponse.data[0],
      hasError: false
    };
  }
  async getBulk(args) {
    const modifierGroupsApiResponse = await settleApiCall(() => this.modifierGroupsClient.getBulk(args));
    if (modifierGroupsApiResponse.hasError) {
      return modifierGroupsApiResponse;
    }
    const {
      data: modifierGroups,
      pagingMetadata
    } = modifierGroupsApiResponse.data;
    const populateModifierGroupsResponse = await this.createPopulatedModifierGroups(modifierGroups);
    if (populateModifierGroupsResponse.hasError) {
      return populateModifierGroupsResponse;
    }
    return {
      data: {
        data: populateModifierGroupsResponse.data,
        pagingMetadata
      },
      hasError: false
    };
  }
  async delete(modifierGroupId) {
    const response = await settleApiCall(() => this.modifierGroupsClient.delete(modifierGroupId));
    return response;
  }
  async bulkDelete(modifierGroupIds) {
    const response = await settleApiCall(() => this.modifierGroupsClient.bulkDelete(modifierGroupIds));
    return response;
  }
  async query(query) {
    const queryModifierGroupsResponse = await settleApiCall(() => this.modifierGroupsClient.query(query));
    if (queryModifierGroupsResponse.hasError) {
      return queryModifierGroupsResponse;
    }
    const populateModifierGroupsResponse = await this.createPopulatedModifierGroups(queryModifierGroupsResponse.data.data);
    if (populateModifierGroupsResponse.hasError) {
      return populateModifierGroupsResponse;
    }
    return {
      data: {
        data: populateModifierGroupsResponse.data,
        pagingMetadata: queryModifierGroupsResponse.data.pagingMetadata
      },
      hasError: false
    };
  }
  async createPopulatedModifierGroups(modifierGroups) {
    const getModifiersResponse = await getModifiers({
      modifiersClient: this.modifiersClient,
      modifierGroups,
      populationLevel: this.populationLevel
    });
    if (getModifiersResponse.hasError) {
      return getModifiersResponse;
    }
    const populatedModifierGroups = modifierGroups.map(modifierGroup => {
      const modifiers = getModifiersResponse.idsToEntityMap ? createDisplayedModifiers(modifierGroup.modifiers, getModifiersResponse.idsToEntityMap) : modifierGroup.modifiers;
      return {
        id: modifierGroup.id,
        revision: modifierGroup.revision,
        name: modifierGroup.name,
        modifiers,
        rule: modifierGroupRuleAdapter(modifierGroup.rule),
        businessLocationIds: modifierGroup.businessLocationIds,
        createdDate: modifierGroup.createdDate
      };
    });
    return {
      data: populatedModifierGroups,
      hasError: false
    };
  }
  async countModifierGroups(filter) {
    const countModifierGroupsResponse = await settleApiCall(() => this.modifierGroupsClient.countModifierGroups(filter));
    return countModifierGroupsResponse;
  }
}
//# sourceMappingURL=PopulatedModifierGroupClient.js.map